import { Type } from "class-transformer";
import HydraEntity from "./HydraEntity";
import "reflect-metadata";
import Teachr from "./Teachr";

declare class PunctualCourse {}


export default class CourseProposalDashboard extends HydraEntity {
    @Type(() => Teachr)
    // teachr: string; // 
    teachr_id?: number;
    // punctualCourse: PunctualCourse;
    @Type(() => Date)
    startDateTime: Date | string;
    @Type(() => Date)
    endDateTime: Date | string;
    teachrPrice: string;
    description?: string | null;
    fees?: number;
    isRefused?: boolean; // the client update this value to true to refuse it
    isFromTeachr?: boolean; // the client update this value to true to refuse it
    lateMinutes?: number; // the teachr update this value to signal he is late
    URSSAFPrice?: number;
    number?: number; // used to blur cards is non premium account in AnswerCardSubscriptionCourse
    stripeFees ?: number;
    totalPrice?: string;
    hourlyPrice?: string;

    depositDate?: Date | string | null;
    deposit?: number | null ;
    proofDeposit?: number | null;
    proofDeposits?: Array<number> | null;
    /** Attestation sur l'honneur d'acompte certifiée (montant ou date modifiés, ou cours sans attestation). */
    depositAttestationAccepted?: boolean | null;

    readonly "@id"?: string;
    readonly "@type"?: string;
    readonly "@context"?: string;
    readonly id?: number;
    @Type(() => Date)
    readonly lastModificationDatetime?: Date | string;
    @Type(() => Date)
    readonly creationDatetime?: Date | string;
    readonly isAccepted?: boolean; // if the proposal has been accepted or not
    courseProposal: any;

    constructor(
        // teachr: string,
        // punctualCourse: string,
        teachrPrice: string,
        startDateTime: Date | string,
        endDateTime: Date | string,
        // description: string | null = null
    ) {
        super();
        // this.teachr = teachr;
        // this.punctualCourse = punctualCourse;
        this.teachrPrice = teachrPrice;
        this.startDateTime = startDateTime;
        this.endDateTime = endDateTime;
        // this.description = description;
    }
}
